import { SET_OPENING_BALANCE_DATA, SET_OPENING_BALANCE_ID } from "constants/openingBalanceConstants";

const initialState: any = {
  id: "",
  openingBalance: [],
};

const openingBalanceReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_OPENING_BALANCE_DATA:
      return {
        ...state,
        openingBalance: action.openingBalance,
      };
    case SET_OPENING_BALANCE_ID:
      return {
        ...state,
        id: action.id,
      };

    default:
      return state;
  }
};

export default openingBalanceReducer;

export interface OpeningBalance {
  message: string;
  accounting: Accounting;
}
export interface Accounting {
  id: number;
  accountingCode: number;
  priceUnit?: null;
  date: string;
  reference: number;
  description: string;
  status?: null;
  currency_exchange: number;
  version: number;
  type_id?: null;
  type?: null;
  synced: boolean;
  offlineInsertion: boolean;
  cloudCode: string;
  setting?: null;
  is_openingBalance: boolean;
  BusinessId: number;
  CurrencyId: number;
  ProjectId?: null;
  BranchId?: null;
  Project?: null;
  Accounting_Items?: AccountingItems[] | null;
  Branch?: null;
}
export interface AccountingItems {
  id: number;
  amount: number;
  currency_amount?: null;
  description: string;
  isCreditor: boolean;
  version: number;
  detail_id?: number | null;
  detail_type?: string | null;
  synced: boolean;
  offlineInsertion: boolean;
  cloudCode: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: null;
  AccountTypeId: number;
  AccountingId: number;
  Account_Type: AccountType;
  detail?: string | null;
  accountType: string;
}
export interface AccountType {
  id: number;
  accountingCode?: null;
  title: string;
  detail: string;
  target_table?: string | null;
  target_model?: null;
  selectable: boolean;
  addable: boolean;
  version: number;
  synced: boolean;
  offlineInsertion: boolean;
  cloudCode?: null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: null;
  parentId: number;
  BusinessId?: null;
}
